import {
  Button, Stack,
} from '@mui/material';
import styled from '@emotion/styled';
import { ACCOUNT_STYLE } from 'bluetail-globals';
import { paletteColor } from 'common/theme/NutailTheme';

const AccountTypePickeButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'isSelected',
})`
  width: 160px;
  height: 130px;
  border: 2px solid ${paletteColor('text.primary')} !important;
  ${({ isSelected }) => isSelected && `background-color: ${paletteColor('activity_info.light')} !important;`}
  color: ${paletteColor('text.primary')};
  border-radius: 4px;
`;

const AccountTypePickerButtonHeader = styled.div`
  font-size: 14px;
  text-transform: none;
  font-weight: bold;
`;

const AccountTypePickerButtonPoint = styled.div`
  font-size: 12px;
  text-transform: none;
  line-height: 1.0;
`;

function View({
  isSelected,
  handleClick,
}) {
  return (
    <AccountTypePickeButton
      variant="outlined"
      isSelected={isSelected}
      onClick={handleClick}
    >
      <Stack direction="column" spacing={1}>
        <AccountTypePickerButtonHeader>
          Traditional
        </AccountTypePickerButtonHeader>
        <AccountTypePickerButtonPoint>
          - Aircraft-oriented.
        </AccountTypePickerButtonPoint>
        <AccountTypePickerButtonPoint>
          - Fleet/Aircraft terminology.
        </AccountTypePickerButtonPoint>
        <AccountTypePickerButtonPoint>
          - CS must add aircraft.
        </AccountTypePickerButtonPoint>
      </Stack>
    </AccountTypePickeButton>
  );
}

function Model({ onClick, isSelected }) {
  const handleClick = () => {
    onClick(ACCOUNT_STYLE.TRADITIONAL);
  };

  const hookProps = {
    isSelected,
    handleClick,
  };

  return (
    <View
      {...hookProps}
    />
  );
}

export default Model;
export { View };
